export default "__VITE_ASSET__Cz5mU7jM__"